<template>
  <div style="width: 100%; height: 100%; margin: 0 !important">
    <sh-notifications v-if="informations !== []">
      <sh-notification-item
        v-for="(item, index) in informations"
        visible="true"
        :key="index"
        :id="index"
        :type="item.type"
        :label="item.label"
        :duration="item.duration"
        >{{ item.text }}</sh-notification-item
      >
    </sh-notifications>

    <issue-modal></issue-modal>
    <feedback-modal></feedback-modal>
    <change-modal></change-modal>
    <manage-subscriptions-modal></manage-subscriptions-modal>

    <access-bar></access-bar>

    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import FeedbackModal from "./components/FeedbackModal.vue";
import IssueModal from "./components/IssueModal.vue";
import ChangeModal from "./components/ChangeLogModal.vue";
import ManageSubscriptionsModal from "./components/ManageSubscriptionsModal.vue";
import AccessBar from "./components/AccessBar.vue";
// import ManualModal from "./components/UserManualModal.vue";

import axios from "axios";
import { vuexOidcUtils } from "vuex-oidc";

export default {
  name: "App",
  components: {
    IssueModal,
    FeedbackModal,
    ChangeModal,
    ManageSubscriptionsModal,
    AccessBar,
    // ManualModal,
  },
  data() {
    return {
      userProfile: { name: "" },
      myInterceptor: null,
    };
  },

  mounted() {
    // console.log(this.oidcStore);
    // console.log(this.$store.state.oidcStore);
    // console.log("___________________________***APP****_______");
    // console.log(this.oidcIsAuthenticated);
    // console.log(this.oidcIdToken);
    // console.log(this.$store.state.oidcStore);
    // console.log(this.oidcUser);

    window.addEventListener("vuexoidc:userLoaded", this.userLoaded);
    window.addEventListener("vuexoidc:userUnloaded", this.userUnloaded);
    window.addEventListener(
      "vuexoidc:silentRenewError",
      this.handleSilentRenewError
    );
    window.addEventListener(
      "vuexoidc:automaticSilentRenewError",
      this.handleAutomaticSilentRenewError
    );
    window.addEventListener("vuexoidc:oidcError", this.handleOidcError);
  },
  unmounted() {
    window.removeEventListener("vuexoidc:userLoaded", this.userLoaded);
    window.removeEventListener("vuexoidc:userUnloaded", this.userUnloaded);
    window.removeEventListener(
      "vuexoidc:silentRenewError",
      this.handleSilentRenewError
    );
    window.removeEventListener(
      "vuexoidc:automaticSilentRenewError",
      this.handleAutomaticSilentRenewError
    );
    window.removeEventListener("vuexoidc:oidcError", this.handleOidcError);
  },
  computed: {
    ...mapGetters(["informations"]),
    ...mapGetters("oidcStore", [
      "oidcIsAuthenticated",
      "oidcAuthenticationIsChecked",
      "oidcUser",
      "oidcIdToken",
      "oidcAccessToken",
      "oidcIdTokenExp",
    ]),
  },
  methods: {
    ...mapActions(["pushNotification"]),
    ...mapActions("oidcStore", ["signOutOidc", "authenticateOidcSilent"]),
    ...mapMutations([
      "clearSelectedRecommendationIndex",
      "clearSelectedActionHist",
    ]),

    getTimestampInSeconds() {
      return Math.floor(Date.now() / 1000);
    },

    userLoaded: function (event) {
      // console.log("I am listening to the user loaded event in vuex-oidc");
      // console.log("this.oidcUser ", this.oidcUser);
      // console.log("event", event);
      // console.log("this.oidcIsAuthenticated ", this.oidcIsAuthenticated);
      // console.log("this.oidcIdToken ", this.oidcIdToken);
      // console.log("this.oidcAccessToken", this.oidcAccessToken);

      // console.log(this.getTimestampInSeconds());

      this.userProfile.name = event.detail.profile.email;

      axios.interceptors.request.eject(this.myInterceptor);
      this.myInterceptor = axios.interceptors.request.use((request) => {
        // console.log(this.$store.getters.backendURL);
        // console.log(request);
        if (request.url.includes(this.$store.getters.backendURL)) {
          request.headers["Authorization"] = `Bearer ${event.detail.id_token}`;
        }
        return request;
      });

      let parsedIDtoken = vuexOidcUtils.parseJwt(event.detail.id_token);
      // console.log(parsedIDtoken);
      // console.log(parsedIDtoken.exp - this.getTimestampInSeconds());
      let setTimeoutPeriod = parsedIDtoken.exp - this.getTimestampInSeconds();
      if (setTimeoutPeriod > 10) setTimeoutPeriod -= 10;
      setTimeoutPeriod *= 1000;

      setTimeout(() => {
        console.log(`Delayed for ${setTimeoutPeriod} miliseconds.`);
        this.authenticateOidcSilent();
      }, setTimeoutPeriod.toString());
    },

    userUnloaded: function () {
      console.log("I am listening to the user unloaded event in vuex-oidc");

      this.userProfile.name = "";
      axios.interceptors.request.eject(this.myInterceptor);
    },

    handleSilentRenewError: function (event) {
      console.log("SilentRenewError_______________________________");
      console.log(event);
      this.signOutOidc();
    },

    handleAutomaticSilentRenewError: function (event) {
      console.log("AutomaticSilentRenewError***********************");
      console.log(event);
      this.signOutOidc();
    },

    handleOidcError: function (payload) {
      console.log("OIDC error in App.vue listener", payload);
      this.signOutOidc();
    },
  },
  watch: {
    selectedArea: function (val) {
      if (val) {
        console.log("Plant Section Selected!");
        this.clearSelectedRecommendationIndex();
        this.clearSelectedActionHist();
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 2px;
}
</style>
